import React, { useState, useRef, useEffect } from 'react';

//****************** Componentes Prime React****************************/
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';


//*****************Componentes Especificos**************** */
import Loader from '../../../../Base/Components/Loader/Loader';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import { getDateProduccionSQL,getMonthNames} from '../../../../Base/Services/FechasService';
import { exportarExcel } from '../../../../Base/Services/ArchivosService';
import { getCalendarioOperativoMensual } from '../../../API/Global/CalendarioOperativo/CalendarioOperativoRequest';
import { getCierreClientes } from '../../../API/Clientes/CierreClientes/CierreClientesRequest'
// import { getCalendarioOperativoMensual } from '../../../../API/Global/CalendarioOperativo/CalendarioOperativoRequest';
// import { getCierreClientes } from '../../../../API/Clientes/CierreClientes/CierreClientesRequest';


const ModalCierreClientes = () => {

    const [cierreDialog, setCierreDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [meses, setMeses] = useState([]);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([])
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [mesOperativoListado, setMesOperativoListado] = useState({})
    const [mes, setMes] = useState(0);
    const [nombreArchivo, setNombreArchivo] = useState('')
    const toast = useRef(null);

    const openNew = () => {
        setCierreDialog(true)
        obtenerCalendarioOperativo()
    }

    const hideDialog = () => {
        setCierreDialog(false)
        setData([])
    }

    const table = {
        Data: data,
        Columns: [
            {
                field: 'CustomerName',
                header: 'CustomerName',
                className: '',
                filter: true
            },
            {
                field: 'BalanceMesAnterior',
                header: 'BalanceCierre',
                className: 'small',
                filter: true,
                Format: 'Currency',
                Sumary: 'sum'
            },
            {
                field: 'CompradoUSD',
                header: 'Compras D',
                className: 'small',
                filter: true,
                Format: 'Currency',
                Sumary: 'sum'
            },
            {
                field: 'CompradoLPS',
                header: 'Compras L',
                className: 'small',
                filter: true,
                Format: 'Currency',
                Sumary: 'sum'
            },

            {
                field: 'CreditoUSD',
                header: 'CreditoD',
                className: 'small',
                filter: true,
                Format: 'Currency',
                Sumary: 'sum'
            },
            {
                field: 'CreditoLPS',
                header: 'Credito L',
                className: 'small',
                filter: true,
                Format: 'Currency',
                Sumary: 'sum'
            },
            {
                field: 'ValorPagado',
                header: 'Pagos',
                className: 'small',
                filter: true,
                Format: 'Currency',
                Sumary: 'sum'
            },
            {
                field: 'BalanceUSD',
                header: 'Balance',
                className: 'small',
                filter: true,
                Format: 'Currency',
                Sumary: 'sum'
            },
        ]
    }



    const obtenerInfoFechas = async (formatoFinal, datosFechas, Mes) => {
        setLoading(true)
        // console.log(Mes)
        const result = await getCierreClientes(formatoFinal, Mes)
        // console.log(result)
        if (result.length > 0) {

            setData(result)
            // console.log(result)

            setLoading(false)
        }
        setTimeout(() => {

        }, 2000);
    }

    const filtrarMeses = async (Mes) => {
        setMes(Mes)
        let mesSeleccionado = meses.filter((e) => Mes === e.IdCDetalle)

        let rangoFechaInicio = new Date(mesSeleccionado[0].FechaInicio)
        let rangoFechaFinal = new Date(mesSeleccionado[0].FechaFinal)

        let datosFechas = [rangoFechaInicio, rangoFechaFinal]


        let formatoFinal = getDateProduccionSQL(datosFechas)
        obtenerInfoFechas(formatoFinal, datosFechas, Mes)

        setMesOperativoListado(mesSeleccionado[0])

    }


    const obtenerCalendarioOperativo = async () => {
        const resultado = await getCalendarioOperativoMensual()

        let calendarioMeses = []
        let language = 'es'
        let m = resultado.map((e) => {
            calendarioMeses.push({
                IdCDetalle: e.IdCDetalle,
                Mes: getMonthNames((e.Mes - 1), language),
                Semanas: e.Semanas,
                FechaInicio: (e.FechaInicio),
                FechaFinal: (e.FechaFinal),
                Anio: e.Ano,
                MesRango: getMonthNames((e.Mes - 1), language) + "-" + e.Ano,
                MesNumero: e.Mes

            })
        })
        let year = new Date().getFullYear();
        let mes = new Date().getMonth() + 1

        let a = calendarioMeses.filter((e) => mes === e.MesNumero && year === e.Anio)
        // setMes(a[0].IdCDetalle)
        let mesAnterior = new Date().getMonth()
        let b = calendarioMeses.filter((e) => mesAnterior === e.MesNumero && year === e.Anio)
        // setMes(a[0].IdCDetalle)
        if(new Date() <= new Date(b[0]?.FechaFinal) ){
            setMes(b[0].IdCDetalle)
    
        }else{
          
            setMes(a[0].IdCDetalle)
        }

        // filtrarMeses(a[0].IdCDetalle)


        setMeses(calendarioMeses)

        // setMesOperativoListado(a[0])
    }

    useEffect(() => {

        if (mes !== 0) {
            filtrarMeses(mes)
        }
    }, [meses])
    return (
        <div>
            <Button onClick={openNew} label='Cierre' icon='ri-token-swap-line' />
            <Dialog visible={cierreDialog} breakpoints={{ '960px': '75vw', '640px': '100vw' }} style={{ width: '85vw', height: '75vh' }}
                onHide={hideDialog} header={<h3>Cierre</h3>}>
                <div>
                    <Dropdown id='IdCDetalle' name='IdCDetalle' style={{ height: 35, width: 180, marginTop: 2 }} className='mx-2'
                        onChange={(e) => filtrarMeses(e.value)} value={mes} optionValue='IdCDetalle' optionLabel='MesRango' options={meses} />
                    <Button icon={'pi pi-file-excel'} className='p-button-success mx-1' onClick={() => { exportarExcel({ ...table, Data: selected.length > 0 ? selected : table.Data }, nombreArchivo) }} />
                </div>
                <div className='pt-4' style={{ height: '60vh' }} id='CierreClientes'>
                    <Loader loading={loading} querySelector='#CierreClientes' />
                    <AgGrid table={table} />
                </div>

            </Dialog>
        </div>
    )
}

export default ModalCierreClientes
